import { Controller } from '@hotwired/stimulus'

// Attaches Mudango's place autocomplete to an address input and fills the city/commune inputs from the selected
// place, using the address component types configured for the country.
//
// Requires the Sprockets `custom_place_autocomplete` script (window.createCustomAutocomplete) on the page.
//
// Minimal usage:
//   <form data-controller="address-autocomplete" data-address-autocomplete-address-types-value='["locality"]'>
//     <input data-address-autocomplete-target="address">
//     <input data-address-autocomplete-target="city">
//     <input data-address-autocomplete-target="comune">
//   </form>
export default class extends Controller {
  static targets = ['address', 'city', 'comune']
  static values = { addressTypes: Array }

  connect() {
    if (!window.createCustomAutocomplete) return

    this.autocomplete = window.createCustomAutocomplete(this.addressTarget, { types: ['geocode'] })
    this.autocomplete.addListener('place_changed', () => this.fillLocality(this.autocomplete.getPlace()))
  }

  disconnect() {
    this.autocomplete?.destroy()
  }

  // Same rule as the checkout invoice form: the last component matching the country's types, never a postal code.
  fillLocality(place) {
    const component = (place?.address_components || [])
      .filter(({ types }) => !types.includes('postal_code') && types.some((type) => this.addressTypesValue.includes(type)))
      .at(-1)
    if (!component) return

    if (this.hasCityTarget) this.cityTarget.value = component.long_name
    if (this.hasComuneTarget) this.comuneTarget.value = component.long_name
  }
}
